/* eslint-disable react/no-children-prop */
import { Route } from 'react-router';
import { ReactNode } from 'react';

export const defaultSignInMountPath = '/login';

export const trimExtraSlashesInUri = (
  uri: string,
  mode: 'start' | 'end' | 'start-end' | 'anywhere' = 'anywhere',
) => {
  if (mode === 'start') {
    return (uri || '').replace(/^[\\/]+/, '/');
  } else if (mode === 'end') {
    return (uri || '').replace(/[\\/]+$/, '/');
  } else if (mode === 'start-end') {
    return (uri || '').replace(/^[\\/]+/, '/').replace(/[\\/]+$/, '/');
  }
  return (uri || '').replace(/[\\/]+/g, '/');
};
export const buildSignInPath = (
  signInMountPath: string,
  ...paths: (string | undefined | null)[]
) => {
  return [signInMountPath, ...paths]
    .filter((a) => !!a)
    .join('/')
    .replace(/[\\/]+/g, '/');
};

export const buildFallbackRoute = (
  key: string,
  renderNotFoundElement: () => ReactNode,
) => {
  return <Route path='*' key={key} children={renderNotFoundElement} />;
};

export const buildPathBuilder = (basePath: string) => {
  const mountPath = trimExtraSlashesInUri(`/${basePath}`);
  return (...paths: string[]) => {
    const normalizedPaths = [mountPath]
      .concat(paths || [])
      .map((a) => trimExtraSlashesInUri(a))
      .filter((a) => !!a && a !== '/');
    const joinedPaths = trimExtraSlashesInUri(normalizedPaths.join('/') || '');
    return joinedPaths;
  };
};
